import {
    rejectRoute,
    getExtData,
    submitExtData,
    uploadPhotoFile,
    photoVerify,
    uploadFaceFile,
    sendBankSms,
    bindBank,
    getSignInfo,
    sign,
    getApplyProcess,
    getPlanList,
    loanConfirm,
    getMobileUrlForXiaoYing,
    getMobileVerifyForXiaoYing,
    getContractForXiaoYing
} from '@/api/daoliu'
import { APPLY_DL_STATUS } from './status';
import Vue from 'vue'
import Store from 'store'

const state = {
    applyId: 0,
    applyStatus: 0,
    vendor: "",
    planList: [],
    sms: {
        seqNumber: '',
        verifyCode: '',
        channel: ''
    },
    checkStatus: {}
}
const getters = {
    applyIdInCookie() {
        return Store.get('applyId');
    },
    userIdInCookie() {
        return Vue.cookie('userId');
    }
}
const mutations = {
    'SET_DL_APPLY' (state, payload) {
        if (payload.applyId) {
            state.applyId = payload.applyId;
            Store.set('applyId', payload.applyId);
            Vue.cookie('applyId', payload.applyId, '1y');
        }
        if (payload.applyStatus) {
            state.applyStatus = payload.applyStatus;
        }
        if (payload.vendor) {
            state.vendor = payload.vendor;
            Vue.cookie('vendor', state.vendor, '1y');
        }
    },
    'SET_DL_BANK_SMS' (state, payload) {
        state.sms = payload
    },
    'SET_DL_CHECK_STATUS' (state, payload) {
        state.checkStatus = payload
    },
    'SET_DL_PLAN_LIST' (state, payload) {
        state.planList = payload
    },
}
const actions = {
    rejectRouteForDL({ commit }, payload) {
        return rejectRoute({
            userId: getters.userIdInCookie(),
            ...payload
        }).then((data) => {
            commit('SET_DL_APPLY', data)
            commit('SET_APPLY', data.applyId)

            if (data.applyRangs && data.applyRangs.length > 0) {
                data.minBalance = data.applyRangs[0].min
                data.maxBalance = data.applyRangs[0].max
                data.stepBalance = data.applyRangs[0].stepBalance
                commit('SET_LOAN', data)
            }
            return Promise.resolve(data)
        })
    },
    getExtDataForDL() {
        return getExtData({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie()
        }).then((data) => {
            return Promise.resolve(data);
        })
    },
    submitExtDataForDL({ commit }, payload) {
        return submitExtData({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
            ...payload
        }).then((data) => {
            commit('SET_DL_APPLY', data)
            commit('SET_APPLY', data.applyId)
            return Promise.resolve(data);
        })
    },
    uploadFileForDL({ state, commit }, payload) {
        return uploadPhotoFile({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
            ...payload
        }).then((data) => {
            return Promise.resolve(data);
        })
    },
    photoVerifyForDL({ commit }, payload) {
        return photoVerify({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
            ...payload
        }).then((data) => {
            commit('SET_DL_APPLY', data)
            commit('SET_APPLY', data.applyId)
            return Promise.resolve(data);
        })
    },
    uploadFaceFileForDL({ commit }, payload) {
        return uploadFaceFile({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
            ...payload
        }).then((data) => {
            commit('SET_DL_APPLY', data)
            commit('SET_APPLY', data.applyId)
            return Promise.resolve(data);
        })
    },
    sendBankSmsForDL({ commit }, payload) {
        return sendBankSms({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
            ...payload
        }).then((data) => {
            commit('SET_DL_BANK_SMS', data)
            return Promise.resolve(data);
        })
    },
    submitBankCardForDL({ state, commit }, payload) {
        return bindBank({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
            ...payload,
            ...state.sms
        }).then((data) => {
            commit('SET_DL_APPLY', data)
            commit('SET_APPLY', data.applyId)
            return Promise.resolve(data);
        })
    },
    getApplyProcessForDL({ commit }) {
        return getApplyProcess({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
        }).then((data) => {
            commit('SET_DL_CHECK_STATUS', data)
            commit('SET_DL_APPLY', data)
            return Promise.resolve();
        })
    },
    getSignInfoForDL({ state }, payload) {
        return getSignInfo({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
            ...payload
        }).then((data) => {
            return Promise.resolve(data);
        })
    },
    getPlanListForDL({ commit }) {
        return getPlanList({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie()
        }).then((data) => {
            commit('SET_DL_PLAN_LIST', data)
            return Promise.resolve(data);
        })
    },
    signForDL({ commit }, payload) {
        return sign({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
            ...payload
        }).then((data) => {
            return Promise.resolve(data);
        })
    },
    loanConfirmForDL({ state, commit }, payload) {
        return loanConfirm(payload).then((data) => {
            commit('SET_DL_APPLY', data)
            commit('SET_APPLY', data.applyId)
            commit('SET_LOAN', data.applyId)
            commit('SET_NEXT_STATE', {
                needNextForDL: true,
                needIdentity: false,
                needSupplement: false,
                needSign: false, // 去签约
                needBindCard: false, // 去绑卡
            })

            return Promise.resolve();
        })
    },
    getMobileUrlForXiaoYing({ commit }, payload) {
        return getMobileUrlForXiaoYing({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
            ...payload
        }).then((data) => {
            return Promise.resolve(data);
        })
    },
    getMobileVerifyForXiaoYing({ commit }) {
        return getMobileVerifyForXiaoYing({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie()
        }).then((data) => {
            return Promise.resolve(data);
        })
    },
    getContractForXiaoYing({ commit }, payload) {
        return getContractForXiaoYing({
            userId: getters.userIdInCookie(),
            applyId: getters.applyIdInCookie(),
            ...payload
        }).then((data) => {
            return Promise.resolve(data);
        })
    },
    nextForDL({ state }, payload) {
        let component = payload.component
        let vendorRoute ='daoliu/vendor2'
        if (state.vendor === "YiXin") {
            vendorRoute = 'daoliu/vendor'
        } else if (state.vendor === "XiaoYing") {
            vendorRoute = 'daoliu/vendor3'
        }
        switch (state.applyStatus) {
            case APPLY_DL_STATUS.APPLY_VENDOR:
                component.$router.replace({
                    name: vendorRoute
                })
                break
            case APPLY_DL_STATUS.APPLY_BANK:
                component.$router.replace({
                    name: 'daoliu/bank'
                })
                break
            case APPLY_DL_STATUS.APPLY_UPLOAD_PHOTO:
                component.$router.replace({
                    name: 'daoliu/identity/photo'
                })
                break
            case APPLY_DL_STATUS.APPLY_UPLOAD_FACE:
                component.$router.replace({
                    name: 'daoliu/identity/face'
                })
                break
            case APPLY_DL_STATUS.APPLY_MOBILE:
                component.$router.replace({
                    name: 'daoliu/mobile'
                })
                break
            case APPLY_DL_STATUS.APPLY_CHECK:
                component.$router.replace({
                    name: 'daoliu/checking'
                })
                break
            case APPLY_DL_STATUS.APPLY_SIGN:
            case APPLY_DL_STATUS.APPLY_SIGNING:
                component.$router.replace({
                    name: 'daoliu/sign'
                })
                break
            case APPLY_DL_STATUS.APPLY_LOANING:
                component.$router.replace({
                    name: 'daoliu/signing'
                })
                break
            default:
                component.$router.replace({
                    name: 'index'
                })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}